class Msg {
	constructor(msg, alertType = 'danger'){
		this.id = Math.random();
		this.msg = msg;
		this.alertType = alertType;
	}
}

export const DISMISS_ALERT = 'DISMISS_ALERT'
export function dismissAlert(alertIndex) {
    return {
        type: DISMISS_ALERT,
        alertIndex: alertIndex
    };
}


export const ADD_ALERT = 'ADD_ALERT'
export function addAlert(msg, type) {
    return {
        type: ADD_ALERT,
        msg: new Msg(msg, type)
    };
}


// WEBPACK FOOTER //
// ./src/App/MsgNotify/msgNotifyActions.js